module.exports = __webpack_public_path__ + "img/button_map.6017bd6a.svg";